import { useSyncExternalStore } from 'react'
import dataService from '../tool/dataService'

const getSnapshot = () => dataService.getAuthSnapshot()

export const useAuth = () => {
  const snapshot = useSyncExternalStore(dataService.subscribeAuth, getSnapshot, getSnapshot)
  const role = (snapshot.userRole || '').toLowerCase()
  const normalizedRole = role === '0' ? 'admin' : role === '1' ? 'manager' : role === '2' ? 'operador' : role

  return {
    ...snapshot,
    role: normalizedRole,
    canWrite: normalizedRole === 'admin' || normalizedRole === 'manager',
    isAdmin: normalizedRole === 'admin',
  }
}
